import React from "react";
import { useState, useEffect } from "react";
import styles from "./style.module.css";
const TextInput = ({ className, value, onChange, isDisabled, updateInstant, readOnly, placeholder, ...retProps }) => {
    const [inputValue, updateInputValue] = useState(value);
    useEffect(() => updateInputValue(value), [value]);
    const handleChange = (val) => {
        updateInputValue(val);
        if (updateInstant) {
            return onChange(val);
        }
    };
    return (React.createElement("textarea", { className: styles.textInput + " " + (isDisabled ? styles.isDisabled : "") + " " + (className ?? ""), value: inputValue, onChange: (val) => handleChange(val.target.value), onBlur: (val) => onChange(val.target.value), disabled: isDisabled, readOnly: readOnly, placeholder: placeholder, ...retProps }));
};
export default TextInput;
